/* Real cart adds for the glow PDP routine cards and the community story player.
   Replaces the old demo handlers that only printed "Internal concept preview". */
(() => {
  'use strict';
  const busy = new WeakSet();

  const statusFor = (button) => {
    const dialog = button.closest('[data-story-dialog]');
    if (dialog) return dialog.querySelector('[data-story-status]');
    const card = button.closest('article');
    return card ? card.querySelector('[data-demo-status]') : null;
  };

  const say = (element, text) => {
    if (!element) return;
    element.hidden = !text;
    element.textContent = text;
  };

  // The header bubble is cosmetic — a failed refresh must never fail the add.
  async function refreshCartCount() {
    try {
      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      const url = new URL(cartUrl, location.origin);
      url.searchParams.set('section_id', 'cart-icon-bubble');
      const response = await fetch(url);
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = html.querySelector('.cart-count-bubble');
      const header = document.getElementById('cart-icon-bubble');
      const previous = header ? header.querySelector('.cart-count-bubble') : null;
      if (previous) {
        if (replacement) previous.replaceWith(replacement);
        else previous.remove();
      } else if (header && replacement) {
        header.append(replacement);
      }
    } catch (_) { /* ignore */ }
  }

  async function add(button) {
    if (busy.has(button)) return;
    const status = statusFor(button);
    const variantId = Number(button.dataset.variantId || 0);
    if (!variantId) {
      say(status, 'This product is unavailable right now.');
      return;
    }
    busy.add(button);
    button.disabled = true;
    say(status, 'Adding…');
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        say(status, data.description || data.message || 'Could not add to cart.');
        return;
      }
      say(status, 'Added to your bag.');
      await refreshCartCount();
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        try {
          window.Shopify.analytics.publish('product_added_to_cart', {
            cartLine: { merchandise: { id: String(variantId) }, quantity: 1 }
          });
        } catch (_) { /* analytics must never block the add */ }
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
      if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.show) window.Rebuy.SmartCart.show();
    } catch (_) {
      say(status, 'Network error — try again.');
    } finally {
      busy.delete(button);
      button.disabled = false;
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-add]');
    if (!button) return;
    event.preventDefault();
    add(button);
  });
})();
